import React, { Component, PropTypes } from 'react';
import { formatNumber, DateFormatter } from '../../utils/date';
import Pixeltext from '../../components/svg/pixeltext';
import forEach from 'lodash/forEach';
import {Link} from 'react-router';
import Image from '../../components/image/image';
import { generateURL } from '../../routes';
import css from './relatedinterviews.scss';

export default class RelatedInterviews extends Component {
	static propTypes = {};
	constructor(props) {
		super(props);

		this.state = {
			showMore: false,
		};
	}

	render() {

		return (
			<section className='related-interviews span14'>
				<div className='related-interviews__top'>
					<h2 className='related-interviews__title'>{this.props.title}</h2>
				</div>
				<ul className='related-interviews__interview-holder'>
					{this.props.interviews.map((interview, i) => this.renderInterview(interview, i))}
				</ul>
				{!this.state.showMore && this.props.interviews.length > 4 && (
					<span className='related-interviews__more pixel-pattern' onClick={() => {this.setState({...this.state, showMore: true})}}>Load more <i className='related-interviews__more__arrow'></i></span>
				)}
			</section>
		);
	}

	renderInterview(interview, i) {
		let releaseDate = new DateFormatter(interview.releaseDate || interview.createdDate);
		let uid = interview.uid || ('interview' + interview.id);
		let type = interview.types.name;

		if (type.slice(-1) == 's') {
			type = type.substr(0,type.length - 1);
		}

		if(!this.state.showMore && i >= 5) {
			return false;
		}

		return (
			<li key={uid} className='related-interviews__interview'>
				<Image className='related-interviews__interview__image span5 hide-mobile' img={interview.image} span='span14' alt='' browser={this.props.browser} />
				{(interview.image) && (
				<Link to={generateURL(interview.types.slug, interview.slug)} className='related-interviews__interview__buttons-container span5 span14-mobile'>
					<div className='related-interviews__interview__button button button--go'>Read {type.toLowerCase()}</div>
				</Link>
				) || (
					<Link to={generateURL(interview.types.slug, interview.slug)} className='related-interviews__interview__buttons-container span14 span14-mobile'>
						<div className='related-interviews__interview__button button button--go'>Read {type.toLowerCase()}</div>
					</Link>
				)}
				<div className='related-interviews__interview__date span2 pixel-pattern hide-tablet hide-mobile'>
					<Pixeltext text={releaseDate.date} className='related-interviews__interview__day' y='15px' textAnchor='end'/>
					<span className='related-interviews__interview__month'>{releaseDate.month} {releaseDate.year}</span>
					<span className='related-interviews__interview__award'>{type + ' —'}</span>
				</div>
				<div className='related-interviews__interview__right span7 span9-tablet span14-mobile'>
					<h4 className='related-interviews__interview__byline'>By {interview.users.name}</h4>
					<h4 className='related-interviews__interview__small-date hide-desktop'>{releaseDate.date + ' ' + releaseDate.month + ', ' + releaseDate.year}</h4>
					<div className='related-interviews__interview__content'>
						<h3 className='related-interviews__interview__title'>{interview.title}</h3>
						<p className='related-interviews__interview__text'>{interview.excerpt}</p>
					</div>
				</div>
			</li>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/relatedinterviews/relatedinterviews.js
 **/